import type { ChangeEvent, Ref } from "react";

interface Props {
  ref?: Ref<HTMLInputElement>;
  acceptedFileTypes: string[];
  multiple?: boolean;
  onFilesAdd: (files: File[]) => void;
}

const HiddenFileInput = ({ ref, acceptedFileTypes, multiple, onFilesAdd }: Props) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files ?? []);
    // Lets the user pick the same file again right away
    event.target.value = "";
    if (files.length > 0) {
      onFilesAdd(files);
    }
  };

  return (
    <input
      ref={ref}
      type="file"
      hidden
      multiple={multiple}
      accept={acceptedFileTypes.join(",")}
      onChange={handleChange}
    />
  );
};

export default HiddenFileInput;
